import { IEId } from '@signing-page/signing/types/eid';

export function getEIdOptions(): IEId[] {
  return [
    {
      name: 'BankId SE',
      key: 'SE',
      icon: 'bankid-color',
    },
    {
      name: 'BankID No',
      key: 'bankid-no',
      height: 220,
      width: 400,
      icon: 'nemid',
    },
    {
      name: 'BankID No Mobile',
      key: 'bankid-no-mobile',
      height: 250,
      width: 400,
      icon: 'nemid',
    },
    {
      name: 'NemID DK',
      key: 'bankid-dk',
      height: 470,
      width: 320,
      icon: 'nemid',
    },
    {
      name: 'NemID for erhverv',
      key: 'bankid-dk-org',
      height: 470,
      width: 320,
      icon: 'nemid',
    },
    {
      name: 'NemID nøglefil',
      key: 'bankid-dk-keyfile',
      height: 350,
      width: 440,
      icon: 'nemid-organization',
    },
  ];
}
